import React, { useReducer, useContext, useCallback } from "react"
import SignInUpReducer from '../state/SignInUpReducer'
import { Commands } from 'shared/resources/BitbiteCommands';
import { SessionContext } from 'shared/system-controls/session/SessionProvider';
import { LanguageContext } from 'shared/i18n/LanguageContext';
import { useNavigate } from "react-router-dom";

export const SignInUpContext = React.createContext();

const SignInUpState = ({ children }) => {
  const initialState = {
    profile: { latitude: 35.6892, longitude: 51.3890 },
    // step: 'RegisterOfficePanel',
  }
  const [state, dispatch] = useReducer(SignInUpReducer, initialState);
  const { userID, asyncServiceCall, openSession, clearSession, person } = useContext(SessionContext);
  const { i18n } = useContext(LanguageContext);
  const navigate = useNavigate();

  //----------------------------------------------------------------
  const signin = useCallback(async ({ username, password, captcha }) => {
    try {
      if (!username || !password) {
        return dispatch({ type: 'SET_STATE_DATA', payload: { requireCheck: true } });
      }
      dispatch({ type: 'LOADING' });
      let res = await asyncServiceCall(Commands.API_URL_BITBITE_SIGN_IN, {
        username: username,
        password: password,
        captcha: captcha,
      });
      // console.log(res);
      setTimeout(() => {
        openSession({ token: res.token, sessionData: { person: res.user }, deviceID: res.deviceID });
        navigate("/");
      }, 100);
    }
    catch (err) {
      // console.log(err?.response || err);
      // if(['INVALID_USERNAME_PASSWORD'].includes(err.response?.data?.message) ){
      //   return dispatch({type:'SET_STATE_DATA', payload:{loading: false,  requireCheck: true, focusInput: 'password', message: err.response?.data?.message}});
      // }
      if (['INVALID_CAPTCHA', 'CAPTCHA_EXPIRED'].includes(err.response?.data?.message)) {
        return dispatch({ type: 'SET_STATE_DATA', payload: { loading: false, requireCheck: true, focusInput: 'captcha', error: err.response?.data?.message } });
      }
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
    }
  }, [asyncServiceCall, navigate, openSession])

  //----------------------------------------------------------------
  const signout = useCallback(async () => {
    try {
      // ssssssssssss
      // console.log('signout');
      dispatch({ type: 'LOADING' });
      await asyncServiceCall(Commands.API_URL_BITBITE_SIGN_OUT, {});
      dispatch({ type: 'LOADED' });
      clearSession();
      navigate("/login");
    }
    catch (err) {
      console.log(err?.response || err);
      clearSession();
    }
  }, [asyncServiceCall, navigate, clearSession])

  //----------------------------------------------------------------
  const signup = useCallback(async (profile) => {
    try {
      dispatch({ type: 'LOADING' });
      await asyncServiceCall(Commands.API_URL_BITBITE_SIGN_UP, {
        username: profile.username,
        password: profile.password,
        profile: profile,
      });
      dispatch({ type: 'LOADED' });
      dispatch({ type: 'SET_STEP', payload: 'UsernamePanel' });
      signin({
        username: profile.username,
        password: profile.password,
      });
    }
    catch (err) {
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
    }
  }, [asyncServiceCall, signin])

  //----------------------------------------------------------------
  const checkAccount = useCallback(async (username) => {
    try {
      dispatch({ type: 'LOADING' });
      let res = await asyncServiceCall(Commands.API_URL_BITBITE_USERNAME_AVAIABLE, {
        username: username,
      });
      if (res.usernameAvailable === 'UNAVAILABLE') {
        return dispatch({ type: 'SET_STEP', payload: 'PasswordPanel' });
      }
      dispatch({ type: 'SET_STEP', payload: 'RegisterPanel' });
      res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_PROVINCES, {});
      dispatch({ type: 'SET_STATE_DATA', payload: { provinces: res } });
    }
    catch (err) {
      // console.log(err)
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: i18n(err.response?.data?.message || (err + "")), type: 'danger' }) });
    }
  }, [asyncServiceCall, i18n])

  //----------------------------------------------------------------
  const getProvinces = useCallback(async () => {
    try {
      let res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_PROVINCES, {});
      dispatch({ type: 'SET_STATE_DATA', payload: { provinces: res } });
    }
    catch (err) {
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: i18n(err.response?.data?.message), type: 'danger' }) });
    }
  }, [asyncServiceCall, i18n])

  //----------------------------------------------------------------
  const getSignInUp = useCallback(async () => {
    try {
      let res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_PROFILE, { userID: userID });
      dispatch({ type: 'LOAD_CUSTOMER_PROFILE', payload: res });
    }
    catch (err) {
      // console.log(err);
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: i18n(err.response?.data?.message), type: 'danger' }) });
    }
  }, [asyncServiceCall, userID, i18n])


  //----------------------------------------------------------------
  const changePassword = useCallback(async ({ username, otpCode, password, getNewCaptcha }) => {
    try {
      if (!username || !otpCode || !password) {
        console.log(username, otpCode, password);
        dispatch({ type: 'SET_STATE_DATA', payload: { requireCheck: true } });
        return
      }
      dispatch({ type: 'LOADING' });
      await asyncServiceCall(Commands.API_URL_BITBITE_CHANGE_PASSWORD, {
        mobile: username,
        otp: otpCode,
        password: password,
      });
      dispatch({ type: 'LOADED' });
      dispatch({ type: 'SET_STEP', payload: 'UsernamePanel' });
    }
    catch (err) {
      dispatch({ type: 'SET_STEP', payload: 'ForgetPasswordPanel' });
      if (['OTP_EXPIRED', 'INVALID_OTP'].includes(err)) {
        getNewCaptcha && getNewCaptcha();
        dispatch({ type: 'SET_STATE_DATA', payload: { requireCheck: true, otpStatus: err } });
      }
      else {
        dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: i18n(err.response?.data?.message), type: 'danger' }) });
      }
    }
  }, [asyncServiceCall, i18n])

  return (
    <SignInUpContext.Provider
      value={{
        state,
        ...state,
        sessionActive: person && true,
        dispatch,
        signin,
        signup,
        signout,
        checkAccount,
        getSignInUp,
        getProvinces,
        changePassword,
      }}
    >
      {children}
    </SignInUpContext.Provider>
  )
}

export default SignInUpState;
